import React from "react";
import { createRoot } from "react-dom/client";
import SEOFooter from "./SEOFooter";

let footerRoot = null;
let footerContainer = null;

export function insertSEOFooterAfterSelector(selector, content) {
  const target = document.querySelector(selector);
  if (!target) {
    console.warn(`No element found for selector "${selector}".`);
    return;
  }

  if (!footerContainer) {
    footerContainer = document.createElement("div");
    target.insertAdjacentElement("afterend", footerContainer);

    footerRoot = createRoot(footerContainer);
  }

  if (footerRoot) {
    footerRoot.render(<SEOFooter content={content} />);
  }
}
